import { LitElement, html } from 'lit-element';
import { styles } from './uc-form-input.styles';
import { inputClear } from '../icons/input-clear';
import { nanoid } from 'nanoid';

export class UcFormInput extends LitElement {
  static get properties() {
    return {
      id: { type: String },
      label: { type: String },
      inputtype: { type: String },
      name: { type: String },
      message: { type: String },
      value: { type: String },
      maxlength: { type: Number },
      minlength: { type: Number },
      isfilled: { type: Boolean },
      haserror: { type: Boolean },
      show: { type: Boolean },
    };
  }

  static styles = styles;

  constructor() {
    super();
    this.id = nanoid();
    this.inputtype = 'text';
    this.label = '';
    this.name = '';
    this.message = '';
    this.isfilled = false;
    this.haserror = false;
    this.show = false;
    this.input = null;
  }

  firstUpdated() {
    this.input = this.renderRoot.querySelector('input');
    this.input.addEventListener('focus', () => {
      this.isfilled = true;
    });
    this.input.addEventListener('blur', event => {
      if (event.target.value === '') {
        this.isfilled = false;
        this.show = false;
      }
    });
    this.input.addEventListener('input', event => {
      if (event.target.value > '0') {
        this.show = true;
      }
    });
  }

  _inputClear(event) {
    event.preventDefault();
    event.stopPropagation();
    this.input.value = '';
    this.input.focus();
  }

  render() {
    return html`
      <div class="form-row${this.haserror ? ' error' : ''}">
        <label class="form__label${this.isfilled ? ' filled' : ''}" for="${this.id}">${this.label}</label>
        <div class="input-wrap">
          <input
            class="form__input"
            id=${this.id}
            type=${this.inputtype}
            name=${this.name}
            autocomplete="off"
            @focus=${e => {
              e.stopPropagation();
              this.handlersInput('focus', e.currentTarget.value);
            }}
            @input=${e => {
              e.stopPropagation();
              this.handlersInput('input', e.currentTarget.value);
            }}
            @blur=${e => {
              e.stopPropagation();
              this.handlersInput('blur', e.currentTarget.value);
            }}
            @change=${e => {
              e.stopPropagation();
              this.handlersInput('change', e.currentTarget.value);
            }}
          />
          <span class="focus-border"></span>
          <uc-button
            class="input-clear${this.show ? ' show' : ''}"
            buttonstyle="text"
            @mousedown=${this._inputClear}
          >
            <button class="clear-icon"><uc-icon>${inputClear}</uc-icon></button>
          </uc-button>
        </div>

        ${this.haserror ? html` <span class="form__message">${this.message}</span> ` : null}
      </div>
    `;
  }

  handlersInput(eventName, value) {
    this.dispatchEvent(
      new CustomEvent(eventName, {
        detail: {
          value,
          name: this.name,
        },
        bubbles: true,
        composed: true,
      })
    );
  }
}
